import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const salespersonRejectProject = createAsyncThunk(
  "managerMainProject/salespersonReject",
  async ({ projectId }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token"); // adjust storage if different
      const response = await axiosInstance.post(
        `${BackendURL}/managerProjectRequested/salesperson-reject`,
        { projectId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data; // { message, project }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to reject project"
      );
    }
  }
);

export const salespersonAcceptProject = createAsyncThunk(
  "managerMainProject/salespersonAccept",
  async ({ projectId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BackendURL}/managerProjectRequested/salesperson-accept`,
        { projectId }, // ✅ plain object (no FormData)
      );
      return response.data; // { message, project }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to accept project"
      );
    }
  }
);

const managerMainProjectSlice = createSlice({
  name: "managerMainProject",
  initialState: {
    projects: [],
    loading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder

    .addCase(salespersonRejectProject.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(salespersonRejectProject.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
        const updatedProject = action.payload.project;
        const index = state.projects.findIndex(
          (p) => p._id === updatedProject._id
        );
        if (index !== -1) {
          state.projects[index] = updatedProject;
        } else {
          state.projects.push(updatedProject);
        }
      })
      .addCase(salespersonRejectProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      .addCase(salespersonAcceptProject.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(salespersonAcceptProject.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
        const updatedProject = action.payload.project;
        const index = state.projects.findIndex(
          (p) => p._id === updatedProject._id
        );
        if (index !== -1) {
          state.projects[index] = updatedProject;
        } else {
          state.projects.push(updatedProject);
        }
      })
      .addCase(salespersonAcceptProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { clearMessages } = managerMainProjectSlice.actions;
export default managerMainProjectSlice.reducer;
